import React from 'react';
import PersonalityGlobe from '../components/PersonalityGlobe';

const Home = () => {
  return <PersonalityGlobe />;
};

export default Home; 